<template>
  <div>
    <v-chip
      :color="chipColor"
      label
      small
    >
      <div class="d-flex">
        <span
          :class="isAFixer ? 'texte-orange-fonce': 'secondary--text'"
          class="texte align-self-center pr-1"
        >
          {{ formattedLibelle }}
        </span>
      </div>
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'TresoMoissonChip',
  props: {
    isAFixer : {
      type: Boolean,
      required: true
    }
  },

  computed: {
    formattedLibelle () {
      return this.isAFixer ? 'Tréso moisson à fixer' : 'Tréso moisson'
    },

    chipColor () {
      return this.isAFixer ?
        '#F6C9B1' :
        'var(--kaki)'
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
